import { render, staticRenderFns } from "./UserDropdownMenu.vue?vue&type=template&id=62831942&"
import script from "./UserDropdownMenu.vue?vue&type=script&lang=js&"
export * from "./UserDropdownMenu.vue?vue&type=script&lang=js&"
import style0 from "./UserDropdownMenu.vue?vue&type=style&index=0&id=62831942&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports